module.exports = __webpack_public_path__ + "static/media/example-2.556c978f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/example-2.jpg
// module id = 213
// module chunks = 0